type ButtonProps = {
    size?: string;
    status?: string;
    children: React.ReactNode;
    className?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    icon?: React.ReactNode;
    iconPosition?: "left" | "right";
    disabled?: boolean;
};

const Button = ({ size, status, children, className, onClick, icon, iconPosition = "left", disabled }: ButtonProps) => {
    return (
        <button
            disabled={disabled}
            onClick={onClick}
            className={`text-center whitespace-nowrap outline-0 justify-center flex gap-1  ${className} ${
                status === "stress"
                    ? "bg-primary3 text-primary2"
                    : status === "error"
                      ? "border border-error text-error"
                      : status === "regist"
                        ? "bg-primary1 text-white"
                        : status === "mobile"
                          ? "bg-gradient-to-r from-[#273219] to-[#4B632B] text-white font-bold"
                          : "border-gray4 border text-gray2"
            } ${size === "L" ? "py-3 text-lg rounded-lg" : size === "M" ? "py-2 rounded-lg" : size === "S" ? "py-1.5 text-sm rounded-lg" : size === "tag" ? "px-2 py-1.5 rounded-[20px] text-sm" : "rounded-lg"}`}
        >
            {icon && iconPosition === "left" && <span>{icon}</span>}
            {children}
            {icon && iconPosition === "right" && <span>{icon}</span>}
        </button>
    );
};

export default Button;
